export class ChangePasswordModel {
    Id: number;
    oldPassword: string = "";
    newPassword: string = "";
    confirmNewPassword: string = "";
}